export default __webpack_public_path__ + "static/media/AkzidenzGrotesk.0c63fcde.woff";